<wlm-side-panel
  *ngIf="map && sidePanelSettings"
  [map]="map"
  [layers]="layerItems"
  [id]="sidePanelId"
  [sidePanelSettings]="sidePanelSettings"
  [mapSettings]="mapSettings"
  class="leaflet-sidebar"
  [ngClass]="{ collapsed: isSidePanelCollapsed }"
  (layerVisibilityChange)="onLayerVisibilityChange($event)"
  (tabSelectionChange)="onTabSelectionChange($event)"
  (layerItemStyleChange)="onLayerItemStyleChange($event)"
  (layerItemsOrderChanged)="onLayerItemsOrderChanged($event)"
></wlm-side-panel>

<wlm-map-time-bar
  *ngIf="map && mapDateRange"
  [id]="timeBarId"
  [map]="map"
  [initialMapDateRange]="mapDateRange"
  [timeBarVelocity]="timeBarVelocity"
  (stepChange)="onStepChanged($event)"
  (dateRangeChange)="onDateRangeChanged($event)"
></wlm-map-time-bar>

<wlm-map-top-bar-buttons
  *ngIf="map && topBarSettings"
  [id]="topBarId"
  class="leaflet-sidebar"
  [map]="map"
  [topBarConfiguration]="topBarSettings"
></wlm-map-top-bar-buttons>

<div class="map-container">
  <div class="map-frame">
    <div #mapContainer class="map" id="map"></div>
  </div>
</div>
